import React, { useState } from "react";
import { Grid, FormControlLabel, Radio, styled, FormLabel, FormControl, RadioGroup } from "@mui/material";
import { departmentList } from "../data";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  columnGap: theme.spacing(2),
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  display: "flex",
}));
const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
  color: theme.palette.grey[900],
  minWidth: theme.spacing(18),
  marginBottom: 0,
}));
const StyledFormControlLabel = styled(FormControlLabel)(() => ({ margin: 0 }));
const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  columnGap: theme.spacing(2),
  alignItems: "center",
  width: "18.25vw",
  minHeight: 40,
}));

function useDepartmentSelector() {
  const [applicationFlow, setApplicationFlow] = useState(Digit?.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null);

  const handleDepartmentOnChange = ({ target: { value } }) => {
    Digit?.SessionStorage.set("CITIZEN.COMMON.HOME.FLOW", value);
    setApplicationFlow(value);
  };

  return [
    applicationFlow === "DA",
    applicationFlow,
    () => (
      <section className="container1" style={{ marginTop: 0 }}>
        <Grid container justifyContent={"center"}>
          <Grid item xs={12} md={6}>
            {applicationFlow === null && (
              <StyledFormControl>
                <StyledFormLabel>
                  Department <span className="compulsoryField">*</span>
                </StyledFormLabel>
                <StyledRadioGroup onChange={handleDepartmentOnChange} aria-labelledby="departments-list" name="department" row>
                  {departmentList?.map((item) => {
                    return <StyledFormControlLabel control={<Radio />} value={item?.value} label={item?.label} key={item?.name} />;
                  })}
                </StyledRadioGroup>
              </StyledFormControl>
            )}
          </Grid>
        </Grid>
      </section>
    ),
  ];
}

export default useDepartmentSelector;
